<template>
  <iframe sandbox="allow-same-origin" ref="internalAnnouncementIframe" width="100%" height="100%" frameborder="0" scrolling="no">
  </iframe>
</template>
<script>
export default {
  name: 'internalAnnouncementContent',
  props: {
    content: {}
  },
  mounted () {
    const iFrameEl = this.$refs['internalAnnouncementIframe']
    iFrameEl.addEventListener('load', function () {
      iFrameEl.style.height = iFrameEl.contentWindow.document.body.scrollHeight + 'px'
    })
    setTimeout(() => {
      const doc = iFrameEl.contentWindow.document
      doc.open()
      doc.write(this.content)
      doc.close()
      iFrameEl.style.height = doc.body.scrollHeight + 'px'
    }, 300) // 100 ms delay, adjust as necessary
  }
}
</script>
